import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";

import { api } from "@/lib/api";
import { DossierItem } from "@/components/dossier-item";
import { TopBar } from "@/components/header";
import { ChipRow, Empty, ErrorView, IconButton, Loading } from "@/components/kit";

const FILTERS = [
  { key: "all", label: "Tous" },
  { key: "active", label: "En cours" },
  { key: "signed", label: "Signés" },
  { key: "recu", label: "Reçus" },
  { key: "contacte", label: "Contactés" },
  { key: "etudie", label: "Étudiés" },
  { key: "devis", label: "Devis" },
];

export default function Dossiers() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("all");
  const q = useQuery({
    queryKey: ["my-dossiers", filter],
    queryFn: () => api(`/recommendations${filter === "all" ? "" : `?status=${filter}`}`),
  });
  return (
    <div data-testid="agent-dossiers-screen" className="flex flex-col">
      <TopBar title="Mes dossiers" right={<IconButton icon={Plus} label="Recommander un client" testID="dossiers-add-button" onClick={() => navigate("/recommend")} />}>
        <ChipRow options={FILTERS} value={filter} onChange={setFilter} testIDPrefix="dossiers-filter" />
      </TopBar>
      {q.isLoading ? (
        <Loading />
      ) : q.isError ? (
        <ErrorView message="Impossible de charger vos dossiers." onRetry={() => q.refetch()} />
      ) : (
        <div data-testid="dossiers-list" className="mx-auto flex w-full max-w-6xl flex-col gap-3 p-4 pb-8 md:p-8">
          {q.data && q.data.length ? (
            <p className="t-caption font-medium">
              {q.data.length} dossier{q.data.length > 1 ? "s" : ""}
            </p>
          ) : null}
          {q.data?.length ? (
            <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
              {q.data.map((d) => <DossierItem key={d.id} d={d} />)}
            </div>
          ) : (
            <Empty title="Aucun dossier" text="Vos recommandations apparaîtront ici avec leur évolution." />
          )}
        </div>
      )}
    </div>
  );
}
